<template>
  <Tooltip
    bottom
    :disabled="!$slots.tooltip"
    :color="tooltipColor"
    :analytics-name="tooltipAnalyticsName"
    :analytics-params="tooltipAnalyticsParams"
  >
    <template #default="{ attrs, on }">
      <VChip
        :class="[
          'mr-2',
          'mb-2',
          { 'px-2': small },
          { 'font-weight-bold': !outlined && color !== 'white' }
        ]"
        :color="color"
        :text-color="textColor"
        :small="small"
        :outlined="outlined"
        label
        v-bind="{ ...$attrs, ...attrs }"
        v-on="{ ...$listeners, ...on }"
      >
        <VIcon
          v-if="icon"
          :x-small="small"
          :small="!small"
          :class="small ? 'mr-1' : 'mr-2'"
          :color="textColor || (outlined && color) || 'grey'"
          v-text="icon"
        />
        <slot />
      </VChip>
    </template>
    <template #tooltip>
      <slot name="tooltip" />
    </template>
  </Tooltip>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import { TooltipParams } from '@/components/mixins/analytics'
import { iconValidator } from '@/components/mixins/icons'
import Tooltip from '@/components/Tooltip.vue'

export default defineComponent({
  components: {
    Tooltip
  },
  props: {
    color: {
      type: String as PropType<string | undefined>,
      default: undefined
    },
    textColor: {
      type: String as PropType<string | undefined>,
      default: undefined
    },
    icon: {
      type: String as PropType<string | undefined>,
      default: undefined,
      validator: iconValidator
    },
    // Automatically enable font-weight-bold on non-white solid background in improve legibility
    autoBold: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    outlined: {
      type: Boolean,
      default: false
    },
    tooltipColor: {
      type: String as PropType<string | undefined>,
      default: undefined
    },
    tooltipAnalyticsName: {
      type: String,
      default: 'ChipLabel'
    }
  },
  setup({ icon, color }) {
    const tooltipAnalyticsParams: TooltipParams = {
      // Only add if defined
      ...(icon ? { icon } : {}),
      ...(color ? { color } : {})
    }
    return {
      tooltipAnalyticsParams
    }
  }
})
</script>
